export default "__VITE_ASSET__C1k9CZuv__"